import { render, staticRenderFns } from "./searchQuotation.vue?vue&type=template&id=075b516d&"
import script from "./searchQuotation.vue?vue&type=script&lang=ts&"
export * from "./searchQuotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports